<template>
<div class="row">
  <footer class="footer">
    <div class="col-md-12">
	    <span class="footer-logo"><img src='@/assets/ey-logo.svg' alt="EY"></span>
		    <div class="footer-text">
				  <p>&#169;{{ new Date().getFullYear() }} Ernst & Young LLP | All Rights Reserved. | content within this application is confidential and meant for EY<br> staff and EY clients only. Please review the <a class="privacy-link" href="">Privacy statement</a>				and<a href="" class="privacy-link"> Master Agreement</a> for Additional references</p>
			</div>
    </div>
	</footer>
</div>
</template>

<script>
export default {
  name: "Footer"
}  
</script>

<style>
footer.footer {
  position:absolute;
  color: #ffffff;
  bottom:0;
  /* height: auto; */
  Width:100%;
  padding-top: 10px;
  text-align: center;
  font-size: 14px;
}
.footer-text {
  padding-top: 10px;
}
.footer-logo {
  height: 42px;
  width: 42px;
}
.privacy-link {
  color: #ffe600;
}
</style>